import React from 'react';
import { MetaPixel } from './src/components/MetaPixel';
import { PurchasePopup } from './src/components/PurchasePopup';
import { Hero } from './src/components/Hero';
import { Testimonials } from './src/components/Testimonials';
import { PainPoints } from './src/components/PainPoints';
import { IsForYou } from './src/components/IsForYou';
import { SystemPitch } from './src/components/SystemPitch';
import { WhatYouGet } from './src/components/WhatYouGet';
import { Bonuses } from './src/components/Bonuses';
import { ComparisonTable } from './src/components/ComparisonTable';
import { LimitedOffer } from './src/components/LimitedOffer';
import { OfferModule } from './src/components/OfferModule';
import { Guarantee } from './src/components/Guarantee';
import { FAQ } from './src/components/FAQ';
import { LastCall } from './src/components/LastCall';
import { Footer } from './src/components/Footer';
export function App() {
  return <div className="min-h-screen bg-cream selection:bg-gold/30 selection:text-brown" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <PurchasePopup data-id="element-2" />

      <main data-id="element-3">
        <Hero data-id="element-4" />
        <Testimonials data-id="element-5" />
        <PainPoints data-id="element-6" />
        <IsForYou data-id="element-7" />
        <SystemPitch data-id="element-8" />
        <WhatYouGet data-id="element-9" />
        <Bonuses data-id="element-10" />
        <ComparisonTable data-id="element-11" />

        <div className="bg-white/50 pb-20" data-id="element-12">
          <LimitedOffer data-id="element-13" />
          <div className="px-4" data-id="element-14">
            <OfferModule data-id="element-15" />
          </div>
        </div>

        <Guarantee data-id="element-16" />
        <FAQ data-id="element-17" />
        <LastCall data-id="element-18" />
      </main>

      <Footer data-id="element-19" />
    </div>;
}